// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Insurer } from './insurer';
import { Rate } from './rate';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class RateType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  rateTypeId!: number;
  createdBy!: string;
  createdDate!: Date;
  description!: string;
  flags?: number;
  locationId!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  insurerDiscountRateTypes!: Insurer[];
  insurerEnablingBondRateTypes!: Insurer[];
  insurerSpecificPenaltyRateTypes!: Insurer[];
  rates!: Rate[];
}

